import { cva } from 'class-variance-authority';
import clsx from 'clsx';
import { IconButton } from '@nula/core-ui';
import styles from './send-stop-button.module.css';

const root = cva(styles.root, {
  variants: {
    mode: {
      send: styles.send,
      stop: styles.stop,
    },
  },
  defaultVariants: { mode: 'send' },
});

interface SendStopButtonProps {
  isRunActive: boolean;
  onSend: () => void;
  onStop: () => void;
  disabled?: boolean;
  className?: string;
}

export function SendStopButton({
  isRunActive,
  onSend,
  onStop,
  disabled,
  className,
}: SendStopButtonProps) {
  if (isRunActive) {
    return (
      <IconButton
        className={clsx(root({ mode: 'stop' }), className)}
        onClick={onStop}
        aria-label="Stop generating"
        title="Stop generating"
      >
        {/* Stop square (■) */}
        <svg width="10" height="10" viewBox="0 0 10 10" fill="currentColor">
          <rect x="0" y="0" width="10" height="10" rx="1" />
        </svg>
      </IconButton>
    );
  }

  return (
    <IconButton
      className={clsx(root({ mode: 'send' }), className)}
      hoverBackground="color-mix(in srgb, var(--primary) 80%, black)"
      pressEffect="glow"
      onClick={onSend}
      disabled={disabled}
      aria-label="Send message"
      title="Send message"
    >
      {/* Arrow up */}
      <svg width="14" height="14" viewBox="0 0 14 14" fill="currentColor">
        <path d="M7 1L7 13M7 1L3 5M7 1L11 5" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" fill="none" />
      </svg>
    </IconButton>
  );
}
